// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner-card[data-v-5124f091]{width:100%}@media (min-width:992px){.banner-card[data-v-5124f091]{height:200px}}.icon-styles[data-v-5124f091]{width:14px;height:14px}.padding-title[data-v-5124f091]{padding-bottom:30px}.padding-button[data-v-5124f091]{padding-top:80px}", ""]);
// Exports
module.exports = exports;
